import React from 'react';
import { Alert, Box, Button, Card, Heading, InputField, space, Stack, styled, Text } from 'bumbag';
import format from 'date-fns/format';
import isToday from 'date-fns/is_today';
import { FastField, Form, Formik } from 'formik';
import * as Loads from 'react-loads-next';

import WithErrorMessage from '@medipass/react-core/WithErrorMessage';
import { FUTURE_TYPES } from '@medipass/utils/constants';
import validate, { isRequired, isValidEmail } from '@medipass/utils/validate-form';
import sdk from '@medipass/web-sdk';

import FinishPage from 'legacy/components/checkout/layout/FinishPage';
import RedirectCountdown from 'legacy/components/checkout/RedirectCountdown';
import { getKeyFromQueryParams } from 'legacy/utils/router';
const ReceiptCard = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;

  @media screen and (max-width: 600px) {
    position: fixed;
    bottom: 0;
    padding: ${space(4, 'major')}rem ${space(2, 'major')}rem;
    max-width: unset;
    width: 100%;
  }
`;
export default function Success() {
  const amount = getKeyFromQueryParams('amount');
  const firstPaymentDate = getKeyFromQueryParams('firstPaymentDate');
  const futureType = getKeyFromQueryParams('futureType');
  const returnUrl = getKeyFromQueryParams('returnUrl');
  const transactionId = getKeyFromQueryParams('transactionId');
  const type = getKeyFromQueryParams('type');
  // If autoSendReceipt is true, that means a receipt has automatically been sent,
  // and we do not need to show the receipt fields on this page.
  const autoSendReceipt = getKeyFromQueryParams('autoSendReceipt') === 'true';
  const sendReceiptEmail = getKeyFromQueryParams('sendReceiptEmail');
  const [receiptEmail, setReceiptEmail] = React.useState('');
  ////////////////////////////////////////////////////////////////////
  const sendReceipt = React.useCallback(
    // @ts-expect-error TS(7006): Parameter 'data' implicitly has an 'any' type.
    async (data, formik) => {
      setReceiptEmail(data.receiptEmail);
      await sdk.transactions.sendReceipt(
        transactionId,
        {
          email: data.receiptEmail,
        },
        {
          requestConfig: {
            tokenType: 'session',
          },
        },
      );
      formik.resetForm();
    },
    [transactionId],
  );
  const sendReceiptLoader = Loads.useDeferredLoads(sendReceipt);
  ////////////////////////////////////////////////////////////////////
  const title = 'Payment approved!';
  ////////////////////////////////////////////////////////////////////

  return (
    <FinishPage
      state="success"
      before={
        amount &&
        !firstPaymentDate && (
          <Box textAlign="center">
            <Text fontSize="500">{amount}</Text>
          </Box>
        )
      }
      after={
        <React.Fragment>
          {futureType === FUTURE_TYPES.INSTALMENT_PLAN && (
            <React.Fragment>
              {firstPaymentDate ? (
                <Box textAlign="center">
                  Your first instalment of <Text fontWeight="semibold">{amount}</Text> will be paid{' '}
                  {isToday(firstPaymentDate) ? (
                    'today'
                  ) : (
                    <Text>
                      on <Text fontWeight="semibold">{format(firstPaymentDate, 'DD/MM/YYYY')}</Text>
                    </Text>
                  )}
                  .
                </Box>
              ) : (
                <Box textAlign="center">Your first instalment was paid successfully.</Box>
              )}
            </React.Fragment>
          )}
          {returnUrl && (
            <Box textAlign="center">
              <RedirectCountdown redirectUrl={returnUrl} />
            </Box>
          )}
          {!returnUrl && type === 'transaction' && !autoSendReceipt && (
            <ReceiptCard marginTop="major-4">
              <Formik
                initialValues={{
                  receiptEmail: sendReceiptEmail || '',
                }}
                onSubmit={sendReceiptLoader.load}
              >
                <Form>
                  <Stack spacing="major-2">
                    <Heading fontSize="400" textAlign="center">
                      Need a receipt?
                    </Heading>
                    <FastField
                      component={InputField.Formik}
                      name="receiptEmail"
                      label="Enter your email address"
                      validate={validate(isRequired, isValidEmail)}
                      type="email"
                    />
                    <Button isLoading={sendReceiptLoader.isPending} palette="secondary" width="100%" type="submit">
                      Send receipt
                    </Button>
                    {sendReceiptLoader.isResolved && (
                      <Alert hasIcon variant="tint" type="success">
                        A receipt has been sent to <Text fontWeight="semibold">{receiptEmail}</Text>
                      </Alert>
                    )}
                    {sendReceiptLoader.isRejected && (
                      <WithErrorMessage
                        isActive
                        // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'Record<s... Remove this comment to see the full error message
                        error={sendReceiptLoader.error}
                        description={`Unable to send receipt to ${receiptEmail}`}
                      />
                    )}
                  </Stack>
                </Form>
              </Formik>
            </ReceiptCard>
          )}
        </React.Fragment>
      }
      title={title}
    />
  );
}
